// formHandlers.js

export const handleInputChange = (e, setForm, Inputs, setErrors, form) => {
    const { name, value } = e.target;
  
    // Actualizar el formulario
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
  
    // Validar el campo específico
    const inputConfig = Inputs.find((input) => input.name === name);
    if (inputConfig && inputConfig.validation) {
      const error = inputConfig.validation(value, form);
      setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
    }
  };
  